import WorkspaceCard from '../atoms/WorkspaceCard';
import React from 'react'

const WorkspacesList = (props: any) => {
const {workspaces} = props;
  return (
    <div className="motif-row gap-y-5">
        {workspaces.map((workspace, index) => {
            return (
                <div key={index} className="motif-col-md-2.5 motif-col-lg-3">
                    <WorkspaceCard {...workspace}/>
                </div>
            )
        })}
    </div>
  )
}

export default WorkspacesList